var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.29 375.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.19,96.36c-2.75-2.79-2.75-7.27,0-10.06L333.22,12.2c4.46-4.53,1.26-12.2-5.11-12.2h-27.84L117.61,182.66h210.5c6.36,0,9.57-7.67,5.11-12.2l-73.02-74.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.14,0H7.17C3.21,0,0,3.21,0,7.17v361.07c0,3.96,3.21,7.17,7.17,7.17h21.4c3.96,0,7.17-3.21,7.17-7.17v-178.41c0-3.96,3.21-7.17,7.17-7.17h25.57L251.14,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStart);
export default __webpack_public_path__ + "static/media/icon-start.3da6c0bbd506cf13dbe662776077cd1f.svg";
export { ForwardRef as ReactComponent };